// extracted by mini-css-extract-plugin
module.exports = {"technology":"technology-icon_technology__QWB_5","technology__hover":"technology-icon_technology__hover__mYp_S","technology__image":"technology-icon_technology__image__z0egV"};